<div class="button-container">
    <div class="button" [ngClass]="{'disabled': disabled}" (click)="$clickHandler($event)" title="{{text | lang}}">
        <div class="text-container flex-col">
            <div class="grow-1"></div>
            <div class="grow-1 flex-row">
                <div class="flex-row grow-1" *ngIf="state">
                    <div class="icon-container">
                        <em class="icon fa fa-spinner fa-pulse"></em>
                    </div>
                </div>
                <div class="grow-2 flex-col text">
                    <div class="grow-1"></div>
                    <div class="grow-1 text-capitalize">{{text | lang}}</div>
                    <div class="grow-1"></div>
                </div>
            </div>
            <div class="grow-1"></div>
        </div>
    </div>
</div>